





































import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { Barva } from '@/modules/ciselnik/dilenske/barva';

import { store } from '../store/edit';
import { editMutations } from '../store/types';

export default Vue.extend({
	name: 'TechStav2',
	components: {
		BarvaSelect: Barva.components.Select,
	},
	props: {
		storeUri: { type: String, required: true },
	},
	data() {
		return {
			mutationsMappers: {
				barva: `${this.storeUri}/${editMutations.BARVA_SELECT}`,
			},
		};
	},
	computed: {
		...genVuexComputeds(store),
		barvaFilter() {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
			};
		},
	},
});
